import { createElement } from 'react';
import './teletext-list-item.scss';
import { Icon } from '@alilc/lowcode-materials';
function getIconStyle(icon) {
    const base = { position: 'absolute', zIndex: 10 };
    switch (icon.position) {
        case 'leftTop': return { ...base, top: '0px', left: '10px' };
        case 'leftBottom': return { ...base, bottom: '0px', left: '10px' };
        case 'rightTop': return { ...base, top: '0px', right: '10px' };
        case 'rightBottom': return { ...base, bottom: '0px', right: '10px' };
        case 'customize': return { ...base, right: `${icon.rightOffset || 0}px`, top: `${icon.topOffset || 0}px` };
        default: return base;
    }
}
function getTextContent(index, title, description, text3, text4) {
    switch (index) {
        case 0: return title || '';
        case 1: return description || '';
        case 2: return text3 || '';
        case 3: return text4 || '';
        default: return '';
    }
}
const TeletextListItem = ({ onClick = () => { }, title, image, imagePlacement, description, type, textLines = 2, itemColumns, itemPadding, iconList, text3, text4, imgWidth = 100, imgHeight = 100, itemBgColor, style, textAlign, isShoppingCart, isWishList, itemType, textImgGap = 16, imgBorderRadius, imgObjectFit, titleColor, titleFontSize, titleFontWeight, titleLineClamp, descriptionColor, descriptionFontSize, descriptionFontWeight, descriptionLineClamp, itemBorderRadius, itemBorderColor, itemBorderWidth, ...otherProps }) => {
    const IconComp = Icon;
    const _otherProps = otherProps || {};
    const resultImage = Array.isArray(image) ? image[0] || '' : image || '';
    const imageStyle = {
        width: `${imgWidth}px`,
        height: `${imgHeight}px`,
        borderRadius: imgBorderRadius != null ? `${imgBorderRadius}px` : undefined,
        objectFit: imgObjectFit,
    };
    const containerClass = `teletext-list__panel__item image-${imagePlacement} itemColumns-${itemColumns}`;
    const containerStyle = {
        padding: itemPadding != null ? `${itemPadding}px` : undefined,
        backgroundColor: itemBgColor,
        alignItems: textAlign,
        gap: `${textImgGap}px`,
        borderRadius: itemBorderRadius != null ? `${itemBorderRadius}px` : undefined,
        border: itemBorderWidth != null || itemBorderColor
            ? `${itemBorderWidth ?? 1}px solid ${itemBorderColor ?? 'transparent'}`
            : undefined,
        ...style,
    };
    const imageEl = resultImage && type !== 'textOnly' ? (createElement("img", { src: resultImage, alt: title || '', className: "teletext-list__panel__item_image", style: imageStyle })) : null;
    const switchRow = type !== 'imgOnly' && itemType === '开关' ? (createElement("div", { className: "teletext-list__panel__item__switch", style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
        createElement("span", { className: "teletext-list__panel__item__switch__title", style: {
                color: titleColor,
                fontSize: titleFontSize != null ? `${titleFontSize}px` : undefined,
                fontWeight: titleFontWeight,
                WebkitLineClamp: titleLineClamp,
            } }, title),
        createElement("label", { className: "teletext-list__panel__item__switch__toggle", onClick: (e) => e.stopPropagation() },
            createElement("input", { type: "checkbox" }),
            createElement("span", { className: "teletext-list__panel__item__switch__slider" })))) : null;
    const textArea = type !== 'imgOnly' && itemType !== '开关' ? (createElement("div", { className: "teletext-list__panel__item__text" },
        Array.from({ length: textLines }).map((_, index) => (createElement("span", { key: index, className: `teletext-list__panel__item__text__${index === 0 ? 'title' : 'description'}`, style: index === 0
                ? {
                    color: titleColor,
                    fontSize: titleFontSize != null ? `${titleFontSize}px` : undefined,
                    fontWeight: titleFontWeight,
                    WebkitLineClamp: titleLineClamp,
                }
                : {
                    color: descriptionColor,
                    fontSize: descriptionFontSize != null ? `${descriptionFontSize}px` : undefined,
                    fontWeight: descriptionFontWeight,
                    WebkitLineClamp: descriptionLineClamp,
                } }, getTextContent(index, title, description, text3, text4)))),
        isShoppingCart && (createElement("div", { className: "shopping-cart-select" },
            createElement("div", { className: "select-box" },
                createElement("select", { className: "teletext-list__panel__item__select" }, [1, 2, 3, 4, 5].map((n) => (createElement("option", { key: n, value: n },
                    "\u6570\u91CF: ",
                    n)))),
                createElement("select", { className: "teletext-list__panel__item__select" }, ['M', 'X', 'XL'].map((s) => (createElement("option", { key: s, value: s },
                    "\u5C3A\u7801: ",
                    s))))),
            createElement("div", { className: "shopping-cart-select__btn" },
                createElement("div", { className: "shopping-cart-select__btn__item" },
                    createElement("img", { className: "shopping-cart-select-img", src: "https://51ymb.com/source/api/upload/1075055372064133120/2025/202501/20250110/1075084331397025792.png", alt: "" }),
                    "Move to wishlist"),
                createElement("div", { className: "remove-box" },
                    createElement("img", { className: "shopping-cart-select-img", src: "https://51ymb.com/source/api/upload/1075055372064133120/2025/202502/20250207/1085235703970926592.png", alt: "" }),
                    "Remove")))),
        isWishList && (createElement("div", { className: "shopping-cart-select__btn" },
            createElement("div", { className: "shopping-cart-select__btn__item" },
                createElement("img", { className: "shopping-cart-select-img", src: "https://51ymb.com/source/api/upload/1075055372064133120/2025/202501/20250110/1075084331397025792.png", alt: "" }),
                "Move to Cart"),
            createElement("div", { className: "remove-box" },
                createElement("img", { className: "shopping-cart-select-img", src: "https://51ymb.com/source/api/upload/1075055372064133120/2025/202502/20250207/1085235703970926592.png", alt: "" }),
                "Remove"))))) : null;
    return (createElement("div", { className: containerClass, onClick: onClick, style: containerStyle, ..._otherProps },
        (imagePlacement === 'left' || imagePlacement === 'top') && imageEl,
        switchRow,
        textArea,
        (imagePlacement === 'right' || imagePlacement === 'bottom') && imageEl,
        iconList?.map((icon, index) => (createElement("div", { key: index, className: `teletext-list__panel__item__icon size-${icon.size}`, style: getIconStyle(icon) }, createElement(IconComp, { type: icon.icon, size: icon.size }))))));
};
TeletextListItem.displayName = 'TeletextListItem';
export default TeletextListItem;
